import { createClient } from '@supabase/supabase-js'

const zipBoundariesUrl = 'https://vchhpkwaysrjrhlllpvt.supabase.co'
const zipBoundariesKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjaGhwa3dheXNyanJobGxscHZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU1OTE5NjcsImV4cCI6MjA1MTE2Nzk2N30.j4BuJLZPtclkPlQq8llLHjR-4kXNdHywPYuNF_EmzQw'

export const zipBoundariesClient = createClient(zipBoundariesUrl, zipBoundariesKey)